import type { CardsTranslations } from "../interfaces/cards";

export const cardsTranslations: CardsTranslations = {
  edit_alias_modal_title: "Edit Card Alias",
  edit_alias_modal_description:
    "The alias is a custom name that helps you easily identify this card in your list.",
  edit_alias_label: "Alias",
  edit_alias_placeholder: "Enter an alias for the card",
  edit_alias_error_required: "Alias is required",
  edit_alias_error_min_length: "Alias must be at least 1 character",
  edit_alias_error_max_length: "Alias cannot exceed 26 characters",
  edit_alias_error_load_data: "Error loading card data",
  edit_alias_button_update: "Update",
  edit_alias_button_cancel: "Cancel",
  edit_alias_success_message: "Alias has been updated successfully",
  edit_alias_error_message: "Error updating card alias",
  card_detail_title: "Card",
  card_detail_back_to_list: "Back to list",
  card_detail_status_label: "Status:",
  card_detail_select_status: "Select status",
  card_detail_loading: "Loading card information...",
  card_detail_error_load: "Error loading card",
  card_detail_error_load_movements: "Error loading movements",
  card_detail_error_load_more_movements: "Error loading more movements",
  card_detail_error_generate_url: "Error generating view URL",
  card_detail_status_update_success: "Card status updated successfully",
  card_detail_status_update_error: "Error updating card status",
  movements_title: "Movements",
  movements_loading: "Loading movements...",
  movements_refresh: "Refresh",
  movements_empty: "No movements to display",
  movements_load_more: "Show more movements",
  movements_loading_more: "Loading more movements...",
  movements_show_more_aria: "Show more movements",
  movements_status_pending: "Pending",
  movements_status_completed: "Completed",
  movements_status_failed: "Failed",
  movements_status_reversed: "Reversed",
  txn_detail_title: "Transaction detail",
  txn_detail_subtitle: "Transaction detail",
  txn_detail_loading: "Loading detail...",
  txn_detail_error_title: "We couldn't load the transaction",
  txn_detail_error_description: "Something went wrong while fetching the detail. Please try again.",
  txn_detail_retry: "Try again",
  txn_detail_close: "Close",
  txn_detail_copy_link: "Copy link",
  txn_detail_link_copied: "Link copied",
  txn_detail_copy_link_error: "We couldn't copy the link. Copy the address from your browser.",
  txn_detail_section_movement: "Movement",
  txn_detail_section_performed_by: "Performed by",
  txn_detail_section_where: "Where",
  txn_detail_section_conversion: "Currency conversion",
  txn_detail_field_type: "Type",
  txn_detail_field_operation: "Operation",
  txn_detail_field_description: "Description",
  txn_detail_field_merchant: "Merchant",
  txn_detail_field_category: "Category",
  txn_detail_field_location: "Location",
  txn_detail_field_terminal: "Terminal / POS",
  txn_detail_field_exchange_rate: "Exchange rate",
  txn_detail_field_spot_variation: "Spot variation",
  txn_detail_field_performed_by_name: "Name",
  txn_detail_field_performed_by_email: "Email",
  txn_detail_operation_credit: "Credit (+)",
  txn_detail_operation_debit: "Debit (−)",
  txn_type_purchase: "Purchase",
  txn_type_topup: "Top-up",
  txn_type_deposit: "Deposit",
  txn_type_refund: "Refund",
  txn_type_atm_withdrawal: "ATM withdrawal",
  txn_type_withdrawal: "Withdrawal",
  txn_type_fee: "Fee",
  txn_type_transfer: "Transfer",
  txn_type_reversal: "Reversal",
  txn_type_adjustment: "Adjustment",
  mcc_category_taxi_rideshare: "Taxis",
  mcc_category_public_transit: "Public transit",
  mcc_category_airlines: "Airlines",
  mcc_category_travel: "Travel & agencies",
  mcc_category_car_rental: "Car rental",
  mcc_category_lodging: "Lodging",
  mcc_category_groceries: "Groceries",
  mcc_category_restaurants: "Restaurants",
  mcc_category_fast_food: "Fast food",
  mcc_category_bars: "Bars",
  mcc_category_liquor: "Liquor stores",
  mcc_category_fuel: "Fuel",
  mcc_category_automotive: "Automotive",
  mcc_category_apparel: "Apparel",
  mcc_category_shoes: "Footwear",
  mcc_category_jewelry: "Jewelry",
  mcc_category_electronics: "Electronics",
  mcc_category_department_stores: "Department stores",
  mcc_category_discount_stores: "Discount stores",
  mcc_category_furniture: "Furniture",
  mcc_category_home_improvement: "Home & hardware",
  mcc_category_books_stationery: "Books & stationery",
  mcc_category_sporting_goods: "Sporting goods",
  mcc_category_toys_hobby: "Toys & hobbies",
  mcc_category_gifts: "Gifts",
  mcc_category_florist: "Florists",
  mcc_category_pets: "Pets",
  mcc_category_cosmetics: "Cosmetics",
  mcc_category_music_media: "Music & video",
  mcc_category_general_retail: "General retail",
  mcc_category_wholesale: "Wholesale",
  mcc_category_technology: "Technology",
  mcc_category_telecom: "Telecom",
  mcc_category_utilities: "Utilities",
  mcc_category_entertainment: "Entertainment",
  mcc_category_gambling: "Gambling",
  mcc_category_medical: "Medical",
  mcc_category_pharmacy: "Pharmacy",
  mcc_category_education: "Education",
  mcc_category_financial: "Financial",
  mcc_category_insurance: "Insurance",
  mcc_category_real_estate: "Real estate",
  mcc_category_professional_services: "Professional services",
  mcc_category_personal_care: "Personal care",
  mcc_category_repair_services: "Repair services",
  mcc_category_cleaning_laundry: "Cleaning & laundry",
  mcc_category_contractors: "Contractors",
  mcc_category_shipping: "Shipping",
  mcc_category_government: "Government",
  mcc_category_charity: "Charity",
  mcc_category_membership_orgs: "Organizations",
  mcc_category_services_other: "Other services",
  card_visual_loading: "Loading card...",
  card_visual_view_title: "Card view",
  card_visual_copy_number: "Copy number",
  card_visual_expires: "Expires",
  card_visual_cvv: "CVV",
  update_status_modal_title: "Change Status",
  update_status_modal_button_cancel: "Cancel",
  update_status_modal_button_confirm: "Change status",
  update_status_modal_warning_title: "Change card status",
  update_status_modal_confirmation_message: "Are you sure you want to change the card status from",
  update_status_modal_to: "to",
  status_active: "Active",
  status_frozen: "Frozen",
  status_disabled: "Disabled",
  status_deleted: "Deleted",
  status_pending_review: "Pending Review",
  table_header_name: "Name",
  table_header_alias: "Alias",
  table_header_provider: "Provider",
  table_header_last4: "Last 4 digits",
  table_header_type: "Type",
  table_header_product: "Product",
  table_header_status: "Status",
  table_header_actions: "Actions",
  table_showing_cards: "Showing",
  table_showing_cards_singular: "card",
  table_showing_cards_plural: "cards",
  table_showing_total: "Total",
  table_show: "Show:",
  table_tooltip_view_detail: "View card details",
  table_tooltip_edit: "Edit card",
  table_tooltip_view_detail_en: "Card detail",
  table_tooltip_edit_en: "Edit card",
  type_credit: "Credit",
  type_debit: "Debit",
  type_prepaid: "Prepaid",
  product_virtual: "Virtual",
  product_physical: "Physical",
  provider_visa: "Visa",
  provider_mastercard: "Mastercard",
  provider_amex: "Amex",
  provider_discover: "Discover",
  provider_other: "Other",
  filters_title: "Filters",
  filters_search_alias_placeholder: "Search by alias...",
  filters_clear: "Clear Filters",
  filters_select_status: "Select status",
  filters_select_provider: "Select provider",
  filters_select_type: "Select type",
  filters_select_product: "Select product",
  filters_cards_created: "CARDS CREATED",
  cards_not_found: "No cards found",
  cards_loading: "Loading cards...",
  cards_error_load: "Error loading cards",
  pagination_first_page: "First page",
  pagination_previous_page: "Previous page",
  pagination_next_page: "Next page",
  pagination_last_page: "Last page",
  pagination_total_pages: "Total pages",
  identities_table_header_name: "Name",
  identities_table_header_document_number: "Document number",
  identities_table_header_nationality: "Nationality",
  identities_table_header_type: "Type",
  identities_table_header_status: "Status",
  identities_table_header_actions: "Actions",
  identities_table_header_cards: "Cards",
  identities_table_showing: "Showing",
  identities_table_showing_singular: "identity",
  identities_table_showing_plural: "identities",
  identities_table_show: "Show:",
  identities_table_tooltip_view_detail: "View identity details",
  identities_table_tooltip_view_detail_en: "Identity detail",
  identities_table_tooltip_create_card: "Create card",
  identities_table_tooltip_create_card_en: "Create card",
  identities_type_select: "Select",
  identities_status_active: "Active",
  identities_status_pending_review: "Pending Review",
  identities_status_rejected: "Rejected",
  identities_header_new_identity_person: "+ New identity (person)",
  identities_header_new_identity_business: "+ New identity (business)",
  identities_header_filter_select_type: "Select type",
  identities_header_identities_created: "IDENTITIES CREATED",
  identities_not_found: "No identities found",
  identities_loading: "Loading identities...",
  identities_error_load: "Error loading identities",
  identities_error_create_card: "Error creating card",
  create_identity_modal_title: "New Identity (person)",
  create_identity_modal_button_cancel: "Cancel",
  create_identity_modal_button_create: "Create holder",
  create_identity_section_organization_title: "Organization Identity",
  create_identity_section_organization_description:
    "Indicate if this identity belongs to the organization itself (its corporate identity). It can be individual (natural person) or business (company). If you send another, it will replace the previous one.",
  create_identity_section_organization_checkbox: "This identity belongs to the organization",
  create_identity_section_identity_title: "Identity Information",
  create_identity_section_identity_description: "Personal and contact information of the identity",
  create_identity_section_address_title: "Address",
  create_identity_section_address_description: "Location and address information",
  create_identity_label_type: "Identity Type",
  create_identity_label_email: "Email",
  create_identity_label_first_name: "First Name",
  create_identity_label_last_name: "Last Name",
  create_identity_label_birthdate: "Birth Date",
  create_identity_label_gender: "Gender",
  create_identity_label_nationality: "Nationality",
  create_identity_label_personal_id_type: "Document Type",
  create_identity_label_personal_id_number: "Document Number",
  create_identity_label_phone: "Phone",
  create_identity_label_country: "Country",
  create_identity_label_city: "City",
  create_identity_label_postal_code: "Postal Code",
  create_identity_label_address_type: "Address Type",
  create_identity_label_address_line_1: "Address Line 1",
  create_identity_label_address_line_2: "Address Line 2",
  create_identity_label_state: "State/Province",
  create_identity_gender_male: "Male",
  create_identity_gender_female: "Female",
  create_identity_gender_other: "Other",
  create_identity_id_type_cc: "CC - Citizenship Card",
  create_identity_id_type_ce: "CE - Foreign ID Card",
  create_identity_id_type_passport: "PASSPORT - Passport",
  create_identity_id_type_nit: "NIT - Tax Identification Number",
  create_identity_id_type_ppt: "PPT - Temporary Protection Permit",
  create_identity_id_type_ine: "INE - Voter ID Card",
  create_identity_id_type_rfc: "RFC - Federal Taxpayer Registry",
  create_identity_id_type_dni: "DNI - National Identity Document",
  create_identity_id_type_le: "LE - Enrollment Booklet",
  create_identity_id_type_lc: "LC - Civic Booklet",
  create_identity_id_type_ci: "CI - Identity Card",
  create_identity_id_type_rg: "RG - General Registry",
  create_identity_id_type_cnh: "CNH - National Driver's License",
  create_identity_id_type_national_id: "NATIONAL_ID - National ID",
  create_identity_id_type_driver_license: "DRIVER_LICENSE - Driver's License",
  create_identity_id_type_residence_permit: "RESIDENCE_PERMIT - Residence Permit",
  create_identity_id_type_cuil: "CUIL - Unique Labor Identification Code",
  create_identity_id_type_cpf: "CPF - Individual Taxpayer Registry",
  create_identity_id_type_cnpj: "CNPJ - Corporate Taxpayer Registry",
  create_identity_id_type_ruc: "RUC - Single Taxpayer Registry",
  create_identity_id_type_rut: "RUT - Single Tax Registry",
  create_identity_id_type_tax_id: "TAX_ID - Tax ID",
  create_identity_label_id_country: "Document Country",
  create_identity_label_identification_type: "Document Type",
  create_identity_label_identification_number: "Document Number",
  create_identity_address_type_registration: "REGISTRATION",
  create_identity_address_type_shipping: "SHIPPING",
  create_identity_address_type_billing: "BILLING",
  create_identity_address_type_kyc: "KYC",
  create_identity_error_address_line_1_required: "Address line 1 is required",
  create_identity_error_address_line_2_required: "Address line 2 is required",
  create_identity_error_city_required: "City is required",
  create_identity_error_state_required: "State/province is required",
  create_identity_error_country_required: "Country is required",
  create_identity_error_postal_code_required: "Postal code is required",
  create_identity_error_email_required: "Email is required",
  create_identity_error_email_invalid: "Email is not valid",
  create_identity_error_first_name_required: "First name is required",
  create_identity_error_last_name_required: "Last name is required",
  create_identity_error_birthdate_required: "Birth date is required",
  create_identity_error_gender_required: "Gender is required",
  create_identity_error_nationality_required: "Nationality is required",
  create_identity_error_personal_id_number_required: "Document number is required",
  create_identity_error_personal_id_type_required: "Document type is required",
  create_identity_error_id_type_invalid_for_country:
    "The document type is not valid for the selected nationality",
  create_identity_error_cpf_digits: "The CPF must have 11 digits.",
  create_identity_error_cnpj_length: "The CNPJ must have 14 characters.",
  create_identity_error_phone_required: "Phone is required",
  create_business_identity_modal_title: "New Identity (business)",
  create_business_identity_section_company_title: "Company Information",
  create_business_identity_section_company_description: "Commercial and legal data of the company",
  create_business_identity_section_owner_title: "Legal Representative Information",
  create_business_identity_section_owner_description: "Personal data of the company owner",
  create_business_identity_section_owner_address_title: "Legal Representative Address",
  create_business_identity_section_owner_address_description: "Location and address information of the owner",
  create_business_identity_section_company_address_title: "Company Address",
  create_business_identity_section_company_address_description:
    "Location and address information of the company",
  create_business_identity_label_name: "Commercial Name",
  create_business_identity_label_business_type: "Entity Type",
  create_business_identity_label_legal_name: "Legal Name",
  create_business_identity_label_tax_id: "NIT / Tax Identification Number",
  create_business_identity_label_incorporation_date: "Incorporation Date",
  create_business_identity_label_country_name: "Country (Name)",
  create_business_identity_label_country_code: "Country Code (ISO3)",
  create_business_identity_label_identification_type: "Document Type (company)",
  create_business_identity_label_identification_number: "Document Number (company)",
  create_business_identity_label_owner_name: "Legal Representative Name",
  create_business_identity_label_owner_id_type: "Legal Representative Document Type",
  create_business_identity_label_owner_id_number: "Legal Representative Document Number",
  create_business_identity_label_owner_address_line1: "Address Line 1",
  create_business_identity_label_owner_city: "City",
  create_business_identity_label_owner_state: "State/Province",
  create_business_identity_label_owner_postal_code: "Postal Code",
  create_business_identity_label_owner_country_code: "Country Code (ISO3)",
  create_business_identity_business_type_llc: "LLC",
  create_business_identity_business_type_sa: "S.A.",
  create_business_identity_business_type_corp: "Corp",
  create_business_identity_business_type_sas: "S.A.S.",
  create_business_identity_business_type_sociedad_anonima: "Public Limited Company",
  create_business_identity_business_type_sociedad_limitada: "Limited Company",
  create_business_identity_business_type_corporacion: "Corporation",
  create_business_identity_business_type_sa_de_cv: "S.A. de C.V.",
  create_business_identity_business_type_s_de_rl_de_cv: "S. de R.L. de C.V.",
  create_business_identity_business_type_sapi_de_cv: "S.A.P.I. de C.V.",
  create_business_identity_business_type_sc: "S.C.",
  create_business_identity_business_type_persona_fisica_ae:
    "Individual with business activity (persona física)",
  create_business_identity_id_type_ssn: "SSN - Social Security Number",
  create_business_identity_id_type_rut: "RUT - Single Tax Registry",
  create_business_identity_error_name_required: "Commercial name is required",
  create_business_identity_error_business_type_required: "Entity type is required",
  create_business_identity_error_legal_name_required: "Legal name is required",
  create_business_identity_error_tax_id_required: "NIT/Tax identification number is required",
  create_business_identity_error_tax_id_invalid: "NIT must only contain letters and numbers",
  create_business_identity_error_incorporation_date_required: "Incorporation date is required",
  create_business_identity_error_country_name_required: "Country name is required",
  create_business_identity_error_country_code_required: "Country code is required",
  create_business_identity_error_owner_name_required: "Legal Representative name is required",
  create_business_identity_error_owner_id_type_required: "Legal Representative document type is required",
  create_business_identity_error_owner_id_number_required: "Legal Representative document number is required",
  create_business_identity_error_owner_address_line1_required: "Legal Representative address is required",
  create_business_identity_error_owner_city_required: "Legal Representative city is required",
  create_business_identity_error_owner_state_required: "Legal Representative state is required",
  create_business_identity_error_owner_postal_code_required: "Legal Representative postal code is required",
  create_business_identity_error_owner_country_code_required: "Legal Representative country code is required",
  identity_detail_title: "Identity Detail",
  identity_detail_back_to_list: "Back to list",
  identity_detail_loading: "Loading identity information...",
  identity_detail_error_load: "Error loading identity",
  identity_detail_status_label: "Status:",
  identity_detail_section_personal_title: "Personal Information",
  identity_detail_section_address_title: "Address",
  identity_detail_section_kyc_title: "KYC Status",
  identity_detail_label_full_name: "Full name",
  identity_detail_label_email: "Email",
  identity_detail_label_phone: "Phone",
  identity_detail_label_gender: "Gender",
  identity_detail_label_document_type: "Document type",
  identity_detail_label_document_number: "Document number",
  identity_detail_label_address_line_1: "Address line 1",
  identity_detail_label_address_line_2: "Address line 2",
  identity_detail_label_city: "City",
  identity_detail_label_country: "Country",
  identity_detail_label_created_at: "Creation date",
  identity_detail_not_specified: "Not specified",
  identity_detail_gender_male: "Male",
  identity_detail_gender_female: "Female",
  identity_detail_gender_other: "Other",
  identity_detail_kyc_status_pending: "Pending",
  identity_detail_kyc_status_in_review: "In review",
  identity_detail_kyc_status_verified: "Verified",
  identity_detail_kyc_status_rejected: "Rejected",
  identity_detail_kyc_status_expired: "Expired",
  organizations_table_header_name: "Name",
  organizations_table_header_email: "Email",
  organizations_table_header_phone: "Phone",
  organizations_table_header_status: "Status",
  organizations_table_header_card_provider: "Card Provider",
  organizations_table_header_actions: "Actions",
  organizations_table_showing: "Showing",
  organizations_table_showing_singular: "organization",
  organizations_table_showing_plural: "organizations",
  organizations_table_show: "Show:",
  organizations_table_tooltip_view_detail: "View organization details",
  organizations_table_tooltip_view_detail_en: "Organization detail",
  organizations_table_tooltip_edit: "Edit organization",
  organizations_table_tooltip_edit_en: "Edit organization",
  organizations_table_tooltip_delete: "Delete organization",
  organizations_table_tooltip_delete_en: "Delete organization",
  organizations_status_active: "Active",
  organizations_status_inactive: "Inactive",
  organizations_status_suspended: "Suspended",
  organizations_status_pending: "Pending",
  organizations_provider_bloque: "Coloca Cards",
  organizations_provider_crypto_mate: "Coloca Crypto",
  organizations_provider_na: "N/A",
  organizations_header_new_organization: "+ New organization",
  organizations_header_organizations_created: "ORGANIZATIONS CREATED",
  organizations_not_found: "No organizations found",
  organizations_loading: "Loading organizations...",
  organizations_error_load: "Error loading organizations",
  organizations_error_update: "Error updating organization",
  organizations_error_delete: "Error deleting organization",
  organizations_error_create: "Error creating organization",
  organizations_success_update: "Organization updated successfully",
  organizations_success_create: "Organization created successfully",
  organization_detail_modal_title: "Organization Detail",
  organization_detail_error_load: "Error loading organization details",
  organization_detail_status_label: "Status:",
  organization_detail_section_basic_title: "Basic Information",
  organization_detail_section_additional_title: "Additional Information",
  organization_detail_label_name: "Name:",
  organization_detail_label_slug: "Slug:",
  organization_detail_label_email: "Email:",
  organization_detail_label_phone: "Phone:",
  organization_detail_label_card_provider: "Card Provider:",
  organization_detail_label_created_at: "Created:",
  organization_detail_label_updated_at: "Updated:",
  organization_detail_not_available: "N/A",
  update_organization_modal_title: "Update Organization",
  update_organization_modal_button_cancel: "Cancel",
  update_organization_modal_button_update: "Update",
  update_organization_modal_description: "Basic organization data",
  update_organization_label_card_provider: "Card Provider",
  update_organization_label_status: "Status",
  update_organization_label_name: "Name",
  update_organization_label_email: "Email",
  update_organization_label_slug: "Slug",
  update_organization_label_phone: "Phone",
  update_organization_info_phone: "International number with country code (without the + symbol)",
  update_organization_error_load_data: "Error loading organization data",
  update_organization_validation_name_required: "Name is required",
  update_organization_validation_name_min_length: "Name must be at least 2 characters",
  update_organization_validation_name_max_length: "Name cannot exceed 255 characters",
  update_organization_validation_slug_max_length: "Slug cannot exceed 255 characters",
  update_organization_validation_email_required: "Email is required",
  update_organization_validation_email_invalid: "Email is not valid",
  update_organization_validation_email_max_length: "Email cannot exceed 255 characters",
  update_organization_validation_phone_max_length: "Phone cannot exceed 20 characters",
  delete_organization_modal_title: "Delete Organization",
  delete_organization_modal_button_cancel: "Cancel",
  delete_organization_modal_button_delete: "Delete",
  delete_organization_modal_warning: "This action cannot be undone",
  delete_organization_modal_confirmation_message:
    "Are you sure you want to delete the organization {{organizationName}}? This action will permanently delete all data associated with this organization.",
  delete_organization_success_modal_title: "Organization Deleted",
  delete_organization_success_modal_button_ok: "OK",
  delete_organization_success_modal_message: "The organization has been successfully deleted.",
  create_organization_modal_title: "New Organization",
  create_organization_modal_button_cancel: "Cancel",
  create_organization_modal_button_create: "Create Organization",
  create_organization_modal_description: "Basic organization data",
  create_organization_info_slug: "Will be automatically generated from the name if left empty",
  create_organization_validation_name_required: "Name is required",
  create_organization_validation_name_min_length: "Name must be at least 2 characters",
  create_organization_validation_name_max_length: "Name cannot exceed 255 characters",
  create_organization_validation_slug_max_length: "Slug cannot exceed 255 characters",
  create_organization_validation_email_required: "Email is required",
  create_organization_validation_email_invalid: "Email is not valid",
  create_organization_validation_email_max_length: "Email cannot exceed 255 characters",
  create_organization_validation_phone_max_length: "Phone cannot exceed 20 characters",
  cards_header_title_organizations: "Organizations",
  cards_header_title_identities: "Holders",
  cards_header_title_cards: "Cards",
  cards_header_title_movements: "Movements",
  cards_header_title_configuration: "Configuration",
  cards_header_title_pockets: "Pockets",
  cards_tab_label_organizations: "Organizations",
  cards_tab_label_identities: "Holders",
  cards_tab_label_cards: "Cards",
  cards_tab_label_pockets: "Pockets",
  balance_refresh_btn: "Refresh balance",
  two_factor_required_to_create_card: "Enable two-factor authentication to create cards",
  two_factor_required_to_view_card: "Enable two-factor authentication to view card data",
  two_factor_required_to_topup_card: "Enable two-factor authentication to load or withdraw balance",
  two_factor_required_to_move_card: "Enable two-factor authentication to move balance between cards",
  two_factor_required_modal_title: "Two-factor authentication required",
  two_factor_required_modal_cancel: "Cancel",
  two_factor_required_modal_go_to_settings: "Go to settings",
  two_factor_challenge_title: "Verify your identity",
  two_factor_challenge_description: "Enter the 6-digit code from your authenticator app to continue.",
  two_factor_challenge_submit: "Verify",
  two_factor_challenge_error_invalid_code: "Incorrect code. Try again.",
  no_permission_contact_admin: "You don't have permission for this action. Contact your administrator.",
  wallet_banner_label: "Card wallet · USD",
  wallet_banner_status_active: "Active",
  wallet_banner_description:
    "What you take off a card comes back here, ready to load onto another instantly.",
  wallet_banner_btn_movements: "Movements",
  wallet_banner_topup_coming_soon: "Coming soon: top up your main balance directly.",
  wallet_banner_allocation_available: "In the wallet",
  wallet_banner_allocation_available_description: "Free balance · not yet assigned to pockets or cards",
  wallet_banner_allocation_pockets: "In pockets",
  wallet_banner_allocation_pockets_description: "Distributed across all pockets",
  wallet_banner_allocation_cards: "In cards",
  wallet_banner_allocation_cards_description: "Loaded on active cards",
  wallet_banner_error_load: "We couldn't load the card wallet balance. Try again.",
  wallet_banner_loading: "Loading balance...",
  wallet_movements_eyebrow_back: "Cards",
  wallet_movements_export: "Export",
  wallet_movements_refresh: "Refresh",
  wallet_movements_stat_balance_label: "In the wallet",
  wallet_movements_stat_balance_description: "Total available",
  wallet_movements_stat_in_label: "Inflows this period",
  wallet_movements_stat_in_description: "Top-ups and deposits",
  wallet_movements_stat_out_label: "Outflows this period",
  wallet_movements_stat_out_description: "Transfers and withdrawals",
  wallet_movements_history_title: "History",
  wallet_movements_history_transfer_button: "Transfer",
  wallet_movements_filter_all: "All",
  wallet_movements_filter_topup: "Top-ups",
  wallet_movements_filter_transfer: "Transfers",
  wallet_movements_filter_withdrawal: "Withdrawals",
  wallet_movements_filter_fee: "Fees",
  pockets_activate_title: "Need to group cards by team or project?",
  pockets_activate_subtitle: "Enable Pockets to share balance across multiple cards and split budgets.",
  pockets_activate_button: "Enable pockets",
  pockets_placeholder_title: "Coming soon",
  pockets_placeholder_description:
    "We're building Pockets so you can group cards and share balance between them.",
  wallet_movements_title: "Card wallet movements",
  wallet_movements_subtitle:
    "Top-ups, transfers to pockets and cards, and fees. Does not include direct card spend.",
  wallet_movements_back: "Back to cards",
  wallet_movements_breadcrumb: "Card wallet movements",
  wallet_movements_filter_type_label: "Type",
  wallet_movements_filter_type_all: "All types",
  wallet_movements_filter_direction_label: "Direction",
  wallet_movements_filter_direction_all: "All",
  wallet_movements_filter_status_label: "Status",
  wallet_movements_filter_status_all: "All statuses",
  wallet_movements_filter_date_from: "From",
  wallet_movements_filter_date_to: "To",
  wallet_movements_filter_clear: "Clear filters",
  wallet_movements_type_topup: "Top-up",
  wallet_movements_type_transfer: "Transfer",
  wallet_movements_type_withdrawal: "Withdrawal",
  wallet_movements_type_fee: "Fee",
  wallet_movements_type_deposit: "Deposit",
  wallet_movements_type_reversal: "Reversal",
  wallet_movements_type_adjustment: "Adjustment",
  wallet_movements_direction_in: "Incoming",
  wallet_movements_direction_out: "Outgoing",
  wallet_movements_status_pending: "Pending",
  wallet_movements_status_completed: "Completed",
  wallet_movements_status_failed: "Failed",
  wallet_movements_status_reversed: "Reversed",
  wallet_movements_empty: "No movements yet",
  wallet_movements_empty_description:
    "There are no movements on this balance yet. Top-ups and transfers will appear here.",
  wallet_movements_loading: "Loading movements...",
  wallet_movements_error_load: "We couldn't load the movements. Please try again.",
  create_card_modal_title: "Create Card",
  create_card_modal_button_cancel: "Cancel",
  create_card_modal_button_create: "Create Card",
  create_card_modal_info_message: "Create new card",
  create_card_modal_confirmation_message:
    "Are you sure you want to create a card for the identity {{identityName}}? A new card associated with this identity will be generated and will be available for use.",
  create_card_success_modal_title: "Card Created",
  create_card_success_modal_button_ok: "OK",
  create_card_success_modal_message: "The card has been created successfully.",
  nationality_col: "Colombian",
  nationality_mex: "Mexican",
  nationality_arg: "Argentine",
  nationality_chl: "Chilean",
  nationality_per: "Peruvian",
  nationality_ecu: "Ecuadorian",
  nationality_bra: "Brazilian",
  nationality_pan: "Panamanian",
  nationality_usa: "American",
  nationality_esp: "Spanish",
  card_new_button: "New card",
  card_new_button_coming_soon: "Coming soon: create cards directly from here.",
  card_new_requires_eligible_holder: "The holder must be active with approved KYC to issue a card.",
  holder_new_button: "New holder",
  pocket_new_button: "New pocket",
  pocket_new_button_coming_soon: "Coming soon: create pockets to group cards.",
  pocket_new_disabled_tooltip: "Temporarily disabled",
  pocket_topup_disabled_tooltip: "Temporarily disabled",
  cards_list_section_title: "All cards",
  cards_list_results_label: "results",
  cards_load_more: "Load more",
  cards_loading_more: "Loading more cards...",
  cards_list_of_total: "of",
  cards_filter_all: "All",
  cards_filter_virtual: "Virtual",
  cards_filter_fisica: "Physical",
  cards_filter_frozen: "Frozen",
  cards_filter_pending: "Pending",
  cards_filter_no_pocket: "No pocket",
  cards_view_list: "List view",
  cards_view_grid: "Grid view",
  cards_sort_label: "Sort",
  cards_sort_newest: "Newest",
  cards_sort_oldest: "Oldest",
  cards_sort_balance_high: "Highest balance",
  cards_sort_balance_low: "Lowest balance",
  cards_search_placeholder: "Search alias, ··last 4…",
  cards_balance_own: "Own balance",
  cards_balance_pocket_prefix: "Pocket · ",
  cards_label_balance_card: "Card balance",
  cards_label_balance_pocket: "Pocket balance",
  cards_label_month_spend: "Spent this month",
  cards_label_shared_among: "shared across {{n}} cards",
  cards_type_virtual_short: "VRT",
  cards_type_fisica_short: "PHY",
  cards_list_empty_title: "No cards",
  cards_list_empty_description:
    "We couldn't find any cards with the applied filters. Try clearing the search or creating a new one.",
  cards_status_active: "Active",
  cards_status_frozen: "Frozen",
  cards_status_disabled: "Disabled",
  cards_status_deleted: "Deleted",
  cards_status_pending_review: "Pending",
  card_detail_export: "Export",
  card_detail_tab_overview: "Overview",
  card_detail_tab_transactions: "Movements",
  card_detail_tab_details: "Sensitive data",
  card_detail_tab_controls: "Controls",
  card_detail_tab_coming_soon_title: "Coming soon",
  card_detail_tab_coming_soon_description: "This section is under construction.",
  card_detail_action_reveal_show: "Show",
  card_detail_action_reveal_hide: "Hide",
  card_detail_action_freeze: "Freeze",
  card_detail_action_unfreeze: "Unfreeze",
  card_detail_action_cancel: "Disable",
  card_detail_action_cancel_coming_soon:
    "Coming soon: you'll be able to disable the card. This action is permanent and irreversible.",
  card_detail_action_email_cardholder: "Email cardholder",
  card_detail_email_modal_title: "Email card data",
  card_detail_email_modal_description: "We'll send the cardholder a secure link to view the full card data.",
  card_detail_email_modal_security_note: "The link is single-use and expires in 15 minutes.",
  card_detail_email_modal_body: "We're about to email the full card data to the cardholder. Continue?",
  card_detail_email_button_confirm: "Send link",
  card_detail_email_button_cancel: "Cancel",
  card_detail_email_two_factor_title: "Confirm with your 2FA code",
  card_detail_email_two_factor_description: "Enter the code from your authenticator app to send the email.",
  card_detail_email_success: "A secure link was sent to the cardholder.",
  card_detail_email_error: "The card data email could not be sent.",
  card_detail_email_error_no_email: "This card has no cardholder email on file.",
  card_detail_more_options: "More options",
  card_detail_menu_delete: "Delete card",
  card_delete_modal_title: "Delete card",
  card_delete_modal_description: 'You are about to delete the card "{{name}}".',
  card_delete_warning_title: "This action is irreversible",
  card_delete_warning_body:
    "The card is cancelled, stops working right away and leaves your card list. Its movements stay in the history. If it still holds balance, move it back to the wallet before deleting it.",
  card_delete_cancel: "Cancel",
  card_delete_confirm: "Delete card",
  card_delete_success: "Card deleted.",
  card_delete_error: "We couldn't delete the card. Try again.",
  update_status_modal_irreversible_title: "This action is irreversible",
  update_status_modal_irreversible_body:
    "Disabling the card is permanent: it cannot be reactivated or recovered. If you just want to pause it, freeze it instead.",
  card_detail_info_title: "Information",
  card_detail_info_type: "Type",
  card_detail_info_brand: "Brand",
  card_detail_info_pocket: "Pocket",
  card_detail_info_holder: "Holder",
  card_detail_info_expires: "Expires",
  card_detail_info_created: "Created",
  card_detail_overview_spend_month: "Spend this month",
  card_detail_overview_loaded_description: "of {{amount}} loaded on the card",
  card_detail_overview_available_balance: "Available balance · {{amount}}",
  // --- Card detail overview redesign ---
  card_stats_range_7d: "7 days",
  card_stats_range_30d: "30 days",
  card_stats_range_90d: "90 days",
  card_stats_range_mtd: "Month-to-date",
  card_stats_range_ytd: "Year-to-date",
  card_stats_range_aria: "Period range",
  card_detail_balance_hero_label: "Available balance",
  card_detail_balance_hero_frozen: "Card is frozen — no new charges accepted.",
  card_detail_balance_hero_no_spend: "No spend in this period.",
  card_detail_balance_hero_runway: "At current pace ({{rate}}/day) it lasts ~{{days}} days.",
  card_detail_balance_status_healthy: "Healthy",
  card_detail_balance_status_attention: "Attention",
  card_detail_balance_status_low: "Low balance",
  card_detail_balance_status_empty: "Empty",
  card_detail_balance_status_frozen: "Frozen",
  card_detail_action_load: "Load",
  card_detail_action_move: "Move",
  card_maintenance_banner_title: "Balance operations under maintenance",
  card_maintenance_banner_description:
    "Balance loads, withdrawals, transfers and new card creation are temporarily disabled. If you need help, contact support.",
  card_retry_issuance_title: "This card could not be issued yet",
  card_retry_issuance_description:
    "The cardholder's details are already saved. Retry the issuance without filling anything in again.",
  card_retry_issuance_action: "Retry issuance",
  card_retry_issuance_success: "Card issued",
  card_retry_issuance_error: "We could not issue the card. Try again in a few minutes.",
  card_detail_action_go_to_pocket: "Go to pocket",
  card_detail_pocket_link_label: "Pocket",
  card_detail_period_loaded_count: "{{count}} loads",
  card_detail_period_net: "Net for the period",
  card_detail_period_net_positive: "Accumulating balance",
  card_detail_period_net_negative: "Draining balance",
  card_detail_period_net_flat: "No change",
  card_detail_chart_title: "Spend over time",
  card_detail_chart_bucket_day: "Per day",
  card_detail_chart_bucket_week: "Per week",
  card_detail_chart_bucket_month: "Per month",
  card_detail_chart_avg: "Avg {{amount}}/day",
  card_detail_chart_empty: "No spend in this period",
  card_detail_chart_week_of: "Week of {{date}}",
  card_detail_chart_in_progress: "{{label}} (in progress)",
  card_detail_chart_bar_aria: "{{label}}: {{amount}}",
  card_detail_recent_title: "Latest movements",
  card_detail_recent_view_all: "View all",
  card_detail_recent_empty: "This card has no movements yet.",
  card_detail_activity_title: "Activity for the period",
  card_detail_activity_subtitle: "Loads, spend and merchants for the period you pick.",
  card_detail_kpi_loaded: "Loaded",
  card_detail_kpi_spent: "Spent",
  card_detail_kpi_spent_detail: "{{count}} transactions · avg {{amount}}",
  card_detail_kpi_declined_some: "See why in Movements",
  card_detail_kpi_declined_none: "No declined payments",
  card_detail_top_merchants_title: "Where the balance goes",
  card_detail_top_merchants_subtitle: "{{count}} merchants · {{label}}",
  card_detail_top_merchants_empty: "No spend in this period.",
  // --- Unified balance modal ---
  balance_modal_title: "Card balance",
  balance_modal_action_load: "Load",
  balance_modal_action_withdraw: "Withdraw",
  balance_modal_action_move: "Move",
  balance_modal_withdraw_all: "Withdraw the whole balance to the wallet",
  balance_modal_amount_label: "Amount",
  balance_modal_amount_helper: "All amounts in USD",
  balance_modal_sending_load: "Loading the card…",
  balance_modal_sending_withdraw: "Withdrawing to the card wallet…",
  balance_modal_sending_move: "Moving the balance…",
  balance_modal_sending_all: "The whole balance",
  balance_transit_wallet: "Card wallet",
  balance_transit_aria: "{{amount}} on its way from {{from}} to {{to}}.",
  balance_modal_wallet_balance_label: "Available in the wallet",
  balance_modal_card_balance_label: "Card balance",
  balance_modal_target_card_label: "Destination card",
  balance_modal_target_card_placeholder: "Pick a card",
  balance_modal_target_empty: "There are no other active cards of the same kind you can move balance to.",
  balance_modal_preset_chip_aria: "Use {{amount}}",
  balance_modal_submit_load: "Load balance",
  balance_modal_submit_withdraw: "Withdraw to wallet",
  balance_modal_submit_move: "Transfer",
  balance_modal_cancel: "Cancel",
  balance_modal_load_success: "Loaded {{amount}} onto the card.",
  balance_modal_withdraw_success: "Withdrew {{amount}} to the card wallet.",
  balance_modal_move_success: "Moved {{amount}} to the other card.",
  balance_modal_load_error: "Could not load the card.",
  balance_modal_withdraw_error: "Could not return the balance to the wallet.",
  balance_modal_move_error: "Could not transfer between cards.",
  balance_modal_amount_required: "Enter an amount.",
  balance_modal_amount_min: "Amount must be greater than $0.",
  balance_modal_amount_over_wallet: "The card wallet doesn't have enough balance.",
  balance_modal_amount_over_card: "The card doesn't have enough balance.",
  balance_modal_target_required: "Select a destination card.",
  card_detail_overview_usage_badge: "{{percent}}% used",
  card_detail_overview_trend_title: "Trend · 6 weeks",
  card_detail_overview_trend_delta: "+{{percent}}% vs last week",
  card_detail_overview_kpi_declined: "Declined",
  card_detail_overview_kpi_period_month: "this month",
  card_detail_overview_kpi_period_30d: "last 30 days",
  card_detail_overview_top_merchants_title: "Top merchants",
  card_topup_modal_open_button: "Add balance",
  card_topup_modal_title: "Add balance",
  card_topup_modal_description: "Add funds from your wallet to use on this card.",
  card_topup_label_amount: "Amount",
  card_topup_label_currency: "Currency",
  card_topup_wallet_current_balace: "Current balance",
  card_balance: "Card balance",
  card_transfer_modal_open_button: "Transfer",
  card_show_data_button: "View details",
  card_hide_data_button: "Hide details",
  card_transfer_label_amount: "Amount",
  card_transfer_label_from: "From",
  card_transfer_label_to: "To",
  card_transfer_modal_description: "Transfer balance to another card.",
  card_transfer_modal_title: "Transfer balance",
  card_transfer_select_card: "Select a card",
  card_transfer_toast_success: "Balance transfer of {{amount}} {{currency}} completed.",
  card_topup_toast_success: "Balance top-up completed for {{amount}} {{currency}}.",
  card_withdrawal_modal_open_button: "Withdraw balance",
  card_withdrawal_modal_title: "Withdraw balance",
  card_withdrawal_modal_description: "Withdraw balance from this card back to your wallet.",
  card_withdrawal_toast_success: "Balance withdrawal completed for {{amount}} {{currency}}.",
  // --- Branding / card design customization ---
  branding_button_personalize: "Customize",
  branding_page_title: "Brand customization",
  branding_page_subtitle: "The secure view of every card in your organization",
  branding_summary_title: "Current setup",
  branding_summary_label_gradient: "Gradient",
  branding_summary_label_logo: "Logo",
  branding_logo_default_coloca: "Coloca (default)",
  branding_logo_custom: "Custom",
  branding_preview_alias: "Your brand · preview",
  branding_preview_holder: "Company",
  branding_loading: "Loading configuration…",
  branding_gradient_section_title: "Background color",
  branding_gradient_section_description: "Pick a curated gradient. Applies to every card.",
  branding_logo_section_title: "Custom logo",
  branding_logo_section_description: "Shown on the corner opposite to the Coloca brand mark.",
  branding_logo_uploader_idle: "Drag your logo or click to upload",
  branding_logo_uploader_constraints: "SVG, PNG or JPG · max 2 MB · transparent background recommended",
  branding_logo_uploading: "Uploading logo…",
  branding_logo_loaded_title: "Logo uploaded",
  branding_logo_loaded_description: "Renders on the top-right corner of the card.",
  branding_logo_button_replace: "Replace",
  branding_logo_button_remove: "Remove logo",
  branding_logo_error_format: "Unsupported format. Use SVG, PNG or JPG.",
  branding_logo_error_size: "Maximum 2 MB.",
  branding_logo_upload_failed: "Could not upload the logo.",
  branding_logo_scale_label: "Logo size",
  branding_button_reset: "Reset",
  branding_button_save: "Save changes",
  branding_footer_default: "You are using the default design.",
  branding_footer_applies_to_all: "These changes apply to every card in the organization.",
  branding_saved: "Design saved.",
  branding_save_failed: "Could not save the design.",
  branding_reset_done: "Design reset to Coloca's default.",
  branding_reset_failed: "Could not reset the design.",
  branding_locked_badge: "Not on",
  branding_locked_title: "Customize your card design",
  branding_locked_description:
    "Pick a gradient and upload your company logo for the secure view of your cards, next to the Coloca mark.",
  branding_locked_cta: "Coloca turns it on per organization: ask for it for yours.",
  branding_no_org_title: "Select an organization",
  branding_no_org_description:
    "Customization is applied per organization. Link an organization to your account to get started.",
  branding_no_org_description_internal:
    "Customization is applied per organization. Open an organization from the list to customize its design.",
  branding_no_org_cta: "Back to cards",
  branding_no_org_cta_internal: "View organizations",
  branding_propagation_notice_title: "Changes take ~1 minute",
  branding_propagation_notice_body:
    "When you save, the new colors and logo are applied immediately to new cards, but cards that are already open may take up to 1 minute to reflect the change. Closing and reopening the card detail shows it instantly.",
  branding_saved_with_delay:
    "Design saved. It may take up to 1 minute to appear on cards already open — close and reopen the detail to see it instantly.",
  branding_logo_uploaded: "Logo uploaded. Remember to click Save to apply it.",
  branding_explainer_title: "Where your design shows",
  branding_explainer_lead:
    "Your colors and logo apply to the secure card view, the one you show through the API.",
  branding_point_iframe_title: "Only in the secure view (iframe)",
  branding_point_iframe_body:
    "It is the view with the card details that you open through the API with its view link, and the one you see in each card's detail.",
  branding_point_wallets_title: "Apple Pay and Google Pay do not change",
  branding_point_wallets_body: "The tokenized card in those wallets keeps the standard Coloca design.",
  branding_point_cobrand_title: "Co-branded with Coloca",
  branding_point_cobrand_body: "Your logo sits next to the Coloca mark, which always shows on the card.",
  branding_point_enabled_title: "Turned on per organization",
  branding_point_enabled_on:
    "Coloca turned it on for your organization. If it is turned off, the card goes back to the Coloca design and your design stays saved.",
  branding_point_enabled_off: "It is not on for your organization yet. Ask Coloca to turn it on.",
  branding_point_enabled_staff:
    "Turn it on in Organizations → Features → Customize card. While it is off, the card goes back to the Coloca design and the saved design is kept.",
  branding_diagram_aria:
    "Your design changes the card in the secure view you open through the API; the card in Apple Pay and Google Pay keeps the standard design",
  branding_diagram_api: "API",
  branding_diagram_secure_view: "Secure view",
  branding_diagram_wallets: "Apple Pay · Google Pay",
  // --- Holders listing + detail redesign ---
  identities_tier_express: "Express",
  identities_tier_express_perk_one_card: "1 virtual card",
  identities_tier_express_perk_monthly_cap: "Cap $500 USD/month",
  identities_tier_verified: "Verified",
  identities_tier_verified_perk_unlimited_virtual: "Unlimited virtual cards",
  identities_tier_verified_perk_monthly_cap: "Cap $5,000 USD/month",
  identities_tier_verified_perk_higher_topups: "Higher top-up limits",
  identities_tier_pro: "Pro",
  identities_tier_pro_perk_physical: "Physical cards",
  identities_tier_pro_perk_no_cap: "No monthly cap",
  identities_tier_pro_perk_funds_origin: "Verified source of funds",
  identities_kyc_approved: "KYC approved",
  identities_kyc_pending: "KYC pending",
  identities_kyc_rejected: "KYC rejected",
  identities_stats_total: "Holders",
  identities_stats_kyc_approved: "KYC approved",
  identities_stats_kyc_pending: "KYC pending",
  identities_filter_all: "All",
  identities_filter_approved: "Approved",
  identities_filter_pending: "Pending",
  identities_filter_rejected: "Rejected",
  identities_view_list: "List view",
  identities_view_grid: "Grid view",
  identities_search_placeholder: "Search by name or document…",
  identities_search_min_length_hint: "Type at least {count} characters to search.",
  identities_empty_title: "No holders",
  identities_empty_description: "No holders registered yet. Create the first one to get started.",
  identities_empty_filtered_title: "No results",
  identities_empty_filtered_description: "No holder matches your search or filters.",
  identities_label_cards: "Cards",
  identities_label_cards_of: "of",
  identities_list_section_title: "All holders",
  identities_header_new_person_short: "New holder",
  identities_header_new_business_short: "New business",
  identity_detail_label_birthdate: "Birth date",
  identity_detail_stats_cards_active: "Active cards",
  identity_detail_stats_month_spend: "Spent this month",
  identity_detail_kyc_section_title: "KYC verification",
  identity_detail_kyc_section_description:
    "Share this link with the holder so they can complete their verification. Copy it or send it by email.",
  identity_detail_kyc_link_placeholder: "Verification link",
  identity_detail_kyc_link_valid_until: "Valid until {{date}}",
  identity_detail_kyc_link_expires_in: "Expires in {{time}}",
  identity_detail_kyc_link_expired: "Link expired",
  identity_detail_kyc_link_empty:
    "There is no live verification link. Generate a new one to share it with the holder.",
  identity_detail_kyc_btn_generate: "Generate link",
  identity_detail_kyc_no_recipient:
    "The holder has no email on record, so there is nobody to send the link to. Copy it and share it another way.",
  identity_detail_kyc_btn_copy: "Copy",
  identity_detail_kyc_btn_copied: "Copied",
  identity_detail_kyc_btn_regenerate: "Regenerate link",
  identity_detail_kyc_btn_send_email: "Send by email",
  identity_detail_kyc_toast_regenerate_success: "A new verification link was generated.",
  identity_detail_kyc_toast_regenerate_error: "Could not regenerate the verification link.",
  identity_detail_kyc_toast_email_success: "Verification email sent.",
  identity_detail_kyc_toast_email_error: "Could not send the verification email.",
  identity_detail_cards_section_title: "Holder's cards",
  identity_detail_cards_empty: "No cards yet.",
  identity_detail_movements_section_title: "Movements",
  identity_detail_movements_coming_soon_title: "Coming soon",
  identity_detail_movements_coming_soon_description: "We are preparing the per-holder movements view.",
  identity_detail_coming_soon: "Coming soon",
  // --- Unified "New holder" modal ---
  identities_header_new_holder: "New holder",
  create_holder_modal_title: "New holder",
  create_holder_modal_description: "Fill in the person's details to create the holder.",
  create_holder_section_personal: "Personal details",
  create_holder_section_address: "Address",
  create_holder_birthdate_format: "Format YYYY-MM-DD (e.g. 1994-02-17).",
  create_holder_birthdate_placeholder: "Pick a date",
  create_holder_birthdate_invalid: "Invalid date. Pick a date from the calendar.",
  create_holder_phone_invalid_for_country: "Invalid phone number for the selected country.",
  create_holder_success: "Holder created.",
  phone_usage_info_button_label: "What we use the phone for",
  phone_usage_modal_title: "What we use the phone for",
  phone_usage_modal_intro: "We use this card phone number for:",
  phone_usage_item_3ds:
    "Security code (3DS): on online purchases we send a one-time code by SMS that the cardholder enters to confirm the payment.",
  phone_usage_item_whatsapp:
    "WhatsApp notifications about card activity (purchases, top-ups, refunds, blocks), when enabled.",
  phone_usage_modal_note: "Make sure the number is correct and can receive SMS and WhatsApp.",
  // --- "New card" modal redesign ---
  create_card_modal_description:
    "Pick a holder and (optionally) a pocket, then create the card. Initial top-ups come later — the card has to be Active first.",
  create_card_no_holder_title: "Create a cardholder first",
  create_card_no_holder_description:
    "To issue cards you need at least one holder: the person the card is issued to. Create one right here and carry on with the card, or go to the holders module to manage the ones that already exist.",
  create_card_no_holder_button: "Go to cardholders",
  // --- Creating a holder from inside the new-card modal ---
  create_card_new_holder_button: "New holder",
  create_card_new_holder_title: "New holder",
  create_card_new_holder_description: "Create the holder without losing the card details you filled in.",
  create_card_new_holder_submit: "Create holder",
  create_card_holder_created_title: "Holder created",
  create_card_holder_created_pending:
    "Their identity still needs to be verified. Until that finishes, they cannot be issued a card.",
  create_card_holder_created_unknown:
    "We could not confirm their status. Look for them in the holders list before creating them again.",
  create_card_holder_created_view: "View holder",
  create_card_holder_created_done: "Got it",
  create_card_holder_pending_notice_title: "{{name}} cannot be issued a card yet",
  create_card_holder_pending_notice_title_unnamed: "This holder cannot be issued a card yet",
  create_card_holder_pending_notice_description:
    "Their identity is being verified. Pick another holder to continue, or open theirs to send the verification link.",
  create_card_label_type: "Card type",
  create_card_type_virtual_title: "Virtual",
  create_card_type_virtual_description: "Ready in seconds. Great for subscriptions and ads.",
  create_card_type_physical_title: "Physical",
  create_card_type_physical_description: "For in-person spend. Integration in progress.",
  create_card_label_alias: "Alias / purpose",
  create_card_alias_placeholder: "e.g. Meta Ads · Q2",
  create_card_label_holder: "Holder",
  create_card_search_holder_placeholder: "Search by name or document…",
  create_card_change_holder: "Change",
  create_card_no_eligible_holders: "No holders yet. Create one from the holders view.",
  create_card_no_matching_holders: "No holders match your search.",
  create_card_holders_none_eligible_title: "No holder can be issued a card yet",
  create_card_holders_none_eligible_description:
    "Your holders are listed below with what is blocking each one. Issuing a card needs their identity verification approved. Open them from the holders view to send the verification link.",
  create_card_label_pocket: "Linked pocket",
  create_card_label_optional: "optional",
  create_card_no_pockets_hint: "No pockets yet. The card will use its own balance.",
  create_card_search_pocket_placeholder: "Search pocket…",
  create_card_pocket_none: "No pocket",
  create_card_pocket_none_description: "The card will use its own balance.",
  create_card_preview_label: "Preview",
  create_card_preview_default_alias: "New card",
  create_card_emission_label: "Issuance",
  create_card_emission_immediate: "Immediate",
  create_card_provisioning_title: "Initial top-up — later",
  create_card_provisioning_body:
    "The provider provisions the card first. Top-ups from your wallet are only possible once it's Active.",
  create_card_success: "Card created. Provisioning with the provider.",
  // --- Pockets ---
  pockets_error_load: "Failed to load pockets",
  pockets_list_section_title: "All pockets",
  pockets_stats_total: "Pockets",
  pockets_stats_total_balance: "Total balance",
  pockets_stats_cards_linked: "Linked cards",
  pockets_stats_month_spend: "Spent this month",
  pockets_search_placeholder: "Search pocket…",
  pockets_empty_title: "No pockets",
  pockets_empty_description: "Create one to group cards by team, project or purpose.",
  pocket_edit_button: "Edit",
  pocket_edit_modal_title: "Edit pocket",
  pocket_edit_modal_description: "Update the name, color or icon. Balance and linked cards stay.",
  pocket_edit_modal_submit: "Save changes",
  pocket_create_modal_title: "New pocket",
  pocket_create_modal_description:
    "Group cards that share the same balance. The initial top-up happens later in a separate step.",
  pocket_create_modal_submit: "Create pocket",
  pocket_create_success: "Pocket created.",
  pocket_create_error: "We couldn't create the pocket.",
  pocket_create_no_org: "You need to belong to an organization to create pockets.",
  pocket_update_success: "Pocket updated.",
  pocket_update_error: "We couldn't update the pocket.",
  pocket_label_name: "Name",
  pocket_label_name_placeholder: "e.g. Marketing Performance",
  pocket_label_color: "Color",
  pocket_label_icon: "Icon",
  pocket_preview_label: "Preview",
  pocket_icon_default: "Default",
  pocket_icon_travel: "Travel",
  pocket_icon_marketing: "Marketing",
  pocket_icon_operations: "Operations",
  pocket_icon_saas: "SaaS",
  pocket_icon_shopping: "Shopping",
  pocket_icon_gift: "Gifts",
  pocket_icon_food: "Food",
  pocket_icon_office: "Office",
  pocket_icon_team: "Team",
  pocket_icon_budget: "Budget",
  pocket_detail_back_to_pockets: "Pockets",
  pocket_detail_hero_balance_label: "Pocket balance",
  pocket_detail_hero_shared_with: "shared with {{count}} cards",
  pocket_detail_hero_outflow: "Spent this month",
  pocket_detail_hero_cards: "Cards",
  pocket_detail_section_cards_title: "Cards",
  pocket_detail_section_cards_empty: "No cards in this pocket yet.",
  pocket_detail_section_movements_title: "Movements",
  pocket_detail_load_balance: "Load pocket",
  pocket_detail_transfer: "Transfer",
  pocket_detail_create_card: "Create card",
  pocket_delete_button: "Delete",
  pocket_delete_modal_title: "Delete pocket",
  pocket_delete_modal_description:
    'You are about to delete the pocket "{name}". This action cannot be undone.',
  pocket_delete_warning:
    "You can only delete a pocket with a zero balance and no linked cards. If it has a balance or cards, withdraw the funds or remove the cards first.",
  pocket_delete_confirm: "Delete pocket",
  pocket_delete_success: "Pocket deleted.",
  pocket_delete_error: "We couldn't delete the pocket.",
  cards_pockets_preview_title: "Pockets",
  cards_pockets_preview_subtitle: "Cards that share a balance, grouped by team or purpose.",
  cards_pockets_preview_view_all: "View all",
  // --- Pocket load/withdraw modal + movements ---
  pocket_load_modal_title: "Pocket movements",
  pocket_load_modal_description:
    "Move balance between your main wallet and this pocket. The provider processes the move immediately.",
  pocket_load_mode_topup: "Top up",
  pocket_load_mode_withdraw: "Return",
  pocket_load_submit_topup: "Top up pocket",
  pocket_load_submit_withdraw: "Return to main",
  pocket_load_wallet_available: "Available: {{amount}}",
  pocket_load_wallet_loading: "Loading main balance…",
  pocket_load_pocket_available: "In the pocket: {{amount}}",
  pocket_load_pocket_balance_label: "Pocket balance",
  pocket_load_success_topup: "Topped up {{amount}} to the pocket.",
  pocket_load_success_withdraw: "Returned {{amount}} to the main balance.",
  pocket_load_pending_reconciliation:
    "The move ran but the bookkeeping update is pending. It'll appear in a few seconds.",
  pocket_load_error: "We couldn't complete the move.",
  pocket_detail_movements_empty_title: "No movements",
  pocket_detail_movements_empty_description:
    "When you load funds or linked cards use this pocket, movements will show here.",
  pocket_load_balance_processing_hint:
    "The balance may take a few seconds to reflect while the provider processes it.",

  statement_page_title: "Card statement",
  statement_back_to_card: "Back to card",
  statement_mode_month: "Month",
  statement_mode_range: "Days",
  statement_mode_lifetime: "Lifetime",
  statement_mode_aria: "Statement period",
  statement_month_label: "Month",
  statement_from_label: "From",
  statement_to_label: "To",
  statement_error_range_invalid: "The end date cannot be earlier than the start date.",
  statement_download_pdf: "Download PDF",
  statement_loading: "Building the statement…",
  statement_error_load: "We couldn't build the statement.",
  statement_error_retry: "Retry",
  statement_notice_truncated_title: "Statement trimmed",
  statement_notice_truncated_description:
    "This period holds {{total}} movements and the statement shows the first {{shown}}. The totals do cover the whole period. Pick a shorter range to see them all.",

  statement_document_title: "Card statement",
  statement_number_label: "Statement no.",
  statement_issued_at_label: "Issued",
  statement_period_label: "Period",
  statement_period_lifetime: "Since opening",
  statement_period_range: "{{from}} — {{to}}",
  statement_card_label: "Card",
  statement_card_type_label: "Type",
  statement_continued: "continued",

  statement_section_holder: "Cardholder",
  statement_section_account: "Account",
  statement_holder_name: "Name",
  statement_holder_document: "Document",
  statement_holder_email: "Email",
  statement_holder_address: "Address",
  statement_account_name: "Legal name",
  statement_account_tax_id: "Tax ID",
  statement_account_address: "Address",
  statement_value_not_available: "Not available",
  statement_holder_source_fallback_note:
    "† Cardholder data comes from the card record; document and address are unavailable.",

  statement_summary_opening_balance: "Opening balance",
  statement_summary_closing_balance: "Closing balance",
  statement_summary_loaded: "Loads",
  statement_summary_spent: "Spend",
  statement_summary_net: "Net for the period",
  statement_summary_available: "Available today",
  statement_summary_declined: "Declined",
  statement_summary_pending: "Pending",
  statement_summary_movements_count: "{{count}} movements",
  statement_summary_estimated_suffix: "estimated",

  statement_section_movements: "Movement detail",
  statement_table_date: "Date",
  statement_table_reference: "Ref.",
  statement_table_merchant: "Description",
  statement_table_category: "Category",
  statement_table_type: "Type",
  statement_table_amount: "Amount",
  statement_table_total_period: "Net total for the period",
  statement_table_empty: "No movements in this period.",
  statement_badge_declined: "Declined",
  statement_badge_pending: "Pending",
  statement_badge_reversed: "Reversed",

  statement_footer_issued: "Statement issued automatically on {{date}}. No handwritten signature required.",
  statement_footer_page: "Page {{current}} of {{total}}",
  statement_footnote_reconciliation:
    "¹ Opening and closing balances are computed from the recorded movements; treat them as a reference.",
  statement_footnote_truncated: "Showing the first {{shown}} of {{total}} movements in the period.",
  statement_footer_declined_excluded: "Declined operations are listed but excluded from the totals.",

  card_deposit_title: "Deposit stablecoins",
  card_deposit_subtitle:
    "Top up this card by sending stablecoins (digital currencies pegged to the dollar) to its address.",
  card_deposit_network_label: "Network",
  card_deposit_address_label: "Deposit address",
  card_deposit_assets_label: "Accepted assets",
  card_deposit_asset_contract: "Contract: {{address}}",
  card_deposit_copy: "Copy address",
  card_deposit_copied: "Copied",
  card_deposit_copied_toast: "Address copied",
  card_deposit_qr_alt: "QR code of the {{network}} deposit address",
  card_deposit_warning:
    "Send only {{assets}} on the {{network}} network. Any other asset or network is not credited and cannot be recovered. Minimum deposit: 1 USD.",
  card_deposit_error: "The card's deposit address could not be loaded. Try again.",
  card_deposit_retry: "Try again",
  card_deposit_inactive: "Deposits are unavailable while the card is not active.",

  // WhatsApp notifications (/app/cards/notifications) — moved out of general Settings.
  notifications_eyebrow: "Product · Cards",
  notifications_nav_label: "WhatsApp alerts",
  notifications_page_title: "WhatsApp notifications",
  notifications_page_subtitle:
    "Coloca notifies the cardholder when something relevant happens on their card. Toggle each type independently; the change applies to every card issued by your organization.",
  notifications_hero_title: "Alerts to the cardholder",
  notifications_hero_sub:
    "Improves the cardholder's security and trust: they learn about every movement as it happens, without opening the app.",
  notifications_footnote: "The alert is sent to the phone registered on each cardholder's identity.",

  notifications_topup_name: "Card top-up",
  notifications_topup_desc: "Notifies the cardholder when their card is funded.",
  notifications_topup_when: "When a card receives a credited top-up.",
  notifications_declined_name: "Declined purchase",
  notifications_declined_desc:
    "Notifies the cardholder when a purchase is declined (insufficient funds, suspected fraud, etc.).",
  notifications_declined_when: "When a purchase with the card is declined.",
  notifications_reversed_name: "Reversed purchase",
  notifications_reversed_desc:
    "Notifies the cardholder when a merchant reverses a purchase and the money returns to the card.",
  notifications_reversed_when: "When a merchant reverses a purchase.",
  notifications_refund_name: "Refund received",
  notifications_refund_desc: "Notifies the cardholder when a refund is credited back to the card.",
  notifications_refund_when: "When a refund is credited to the card.",
  notifications_blocked_name: "Card blocked",
  notifications_blocked_desc: "Notifies the cardholder when their card is frozen or disabled.",
  notifications_blocked_when: "When the card is frozen or disabled.",
  notifications_unblocked_name: "Card unblocked",
  notifications_unblocked_desc: "Tells the cardholder when their card is active again after a block.",
  notifications_unblocked_when: "When a blocked card becomes active again.",
  notifications_withdrawal_name: "Balance withdrawal",
  notifications_withdrawal_desc:
    "Tells the cardholder when balance is withdrawn from their card to the organization's wallet.",
  notifications_withdrawal_when: "When balance is withdrawn from the card.",
  notifications_balance_low_name: "Low balance",
  notifications_balance_low_desc:
    "Notifies the cardholder when the card balance drops below the threshold you set.",
  notifications_balance_low_when: "When the card balance drops below the threshold you set.",
  notifications_balance_low_threshold_label: "Low-balance threshold",
  notifications_balance_low_threshold_help:
    "Amount in USD. If a card's balance drops below this value after a purchase, the alert is sent.",
  notifications_balance_low_threshold_required_error:
    "Set a positive USD threshold before enabling this alert.",
  notifications_balance_low_threshold_prefix: "USD",
  notifications_approved_name: "Approved purchase",
  notifications_approved_desc:
    "Notifies the cardholder of every approved purchase, once per purchase. High volume: turn it on only if your customers asked for it.",
  notifications_approved_when: "When a purchase with the card is approved.",
  notifications_approved_opt_in_tag: "OPT-IN",

  notifications_enable_confirm_title: "Turn on the “{{name}}” alert?",
  notifications_enable_confirm_intro:
    "Turning it on makes Coloca start sending real messages to your cardholders.",
  notifications_enable_confirm_who_title: "Who receives them?",
  notifications_enable_confirm_who_body: "The phone registered on each cardholder's identity.",
  notifications_enable_confirm_when_title: "When?",
  notifications_enable_confirm_reversible:
    "You can turn it off at any time — it does not affect already-issued cards.",
  notifications_enable_confirm_button: "Yes, enable",
  notifications_enable_confirm_cancel: "Cancel",

  notifications_bubble_topup_body:
    "Hola Cliente, tu recarga de $ 50.000 a la tarjeta terminada en 4321 se procesó exitosamente.\n\nFecha: 21 de mayo de 2026 a las 14:30\nSaldo actual: $ 250.000\nID de transacción: TXN-A8K2R9\n\nGracias por usar Coloca Payments.",
  notifications_bubble_declined_body:
    "Tu compra de USD 3,72 en Netflix no se aprobó.\nMotivo: Fondos insuficientes\nTarjeta Coloca •••• 8707 · 5 oct 2026 · 1:11 p. m.\n¿No fuiste tú? Escríbenos por aquí.",
  notifications_bubble_reversed_body:
    "El comercio reversó tu compra de COP 14.000 en Good One Lab.\nTarjeta Coloca •••• 8707 · 5 oct 2026 · 1:11 p. m.\nEl dinero ya volvió a tu saldo.",
  notifications_bubble_refund_body:
    "Recibiste un reembolso de BRL 14,00 de Uber.\nTarjeta Coloca •••• 8707 · 5 oct 2026 · 1:11 p. m.\nEl saldo ya está disponible.",
  notifications_bubble_blocked_body:
    "Tu tarjeta Coloca •••• 8707 quedó bloqueada.\nMotivo: Varios intentos fallidos de PIN\nSi no fuiste tú quien la bloqueó, escríbenos por aquí.",
  notifications_bubble_balance_low_body:
    "Tu saldo disponible bajó de USD 500,00.\nSaldo actual: USD 438,25\nTarjeta Coloca •••• 8707\nPuedes recargar desde la app de Coloca.",
  notifications_bubble_approved_body:
    "Pagaste COP 14.000 en Good One Lab.\nTarjeta Coloca •••• 8707 · 5 oct 2026 · 1:11 p. m.\n¿No la reconoces? Escríbenos por aquí.",
  notifications_bubble_unblocked_body:
    "Tu tarjeta Coloca •••• 8707 quedó desbloqueada.\n\nYa puedes usarla de nuevo.",
  notifications_bubble_withdrawal_body:
    "Se retiraron USD 120,00 de tu tarjeta Coloca •••• 8707.\nSaldo actual: USD 318,25\n5 oct 2026 · 1:11 p. m.\n\n¿No reconoces este movimiento? Escríbenos por aquí.",
  notifications_bubble_declined_title: "Compra rechazada",
  notifications_bubble_reversed_title: "Compra reversada",
  notifications_bubble_refund_title: "Reembolso recibido",
  notifications_bubble_blocked_title: "Tarjeta bloqueada",
  notifications_bubble_unblocked_title: "Tarjeta desbloqueada",
  notifications_bubble_withdrawal_title: "Retiro de saldo",
  notifications_bubble_balance_low_title: "Saldo bajo",
  notifications_bubble_approved_title: "Compra aprobada",
  notifications_bubble_recipient_hint: "Sent to the cardholder's phone",
  cop_top_up_unavailable_permission: "Your user is not allowed to load cards from pesos.",
  cop_top_up_unavailable_card: "This card cannot be loaded from pesos.",
  cop_top_up_unavailable_card_inactive: "The card has to be active.",
  cop_top_up_unavailable_crypto_off: "Crypto is not active for your organization.",
  cop_top_up_unavailable_breb_key: "Create your Bre-B key to use your pesos.",
  cop_top_up_unavailable_verification: "Finish your organization's verification.",
  cop_top_up_unavailable_fee: "We could not read the card's fee. Try again in a few minutes.",
  cop_top_up_unavailable_maintenance: "Under maintenance.",
  cop_top_up_unavailable_generic: "Not available right now.",
  cop_top_up_title: "Load from pesos",
  cop_top_up_description: "We use your peso balance to load card •••• {{last4}}.",
  cop_top_up_step_amount: "Amount",
  cop_top_up_step_review: "Review",
  cop_top_up_step_result: "Delivery",
  cop_top_up_pay_label: "You pay",
  cop_top_up_credit_label: "Reaches the card",
  cop_top_up_balance: "Available: {{amount}}",
  cop_top_up_limits: "From {{min}} per top-up",
  cop_top_up_issue_below_min: "The minimum is {{min}}.",
  cop_top_up_issue_above_max: "The maximum is {{max}}.",
  cop_top_up_issue_balance: "Your peso balance is not enough.",
  cop_top_up_issue_precision: "Check the amount's decimals.",
  cop_top_up_issue_invalid: "Type a valid amount.",
  cop_top_up_pricing: "Pricing…",
  cop_top_up_type_amount: "Type what you want to pay or what should reach the card.",
  cop_top_up_trail_pesos: "Your pesos",
  cop_top_up_trail_usdt: "Travel as USDT",
  cop_top_up_trail_card: "Card •••• {{last4}}",
  cop_top_up_row_pay: "You pay",
  cop_top_up_row_price: "Price per dollar",
  cop_top_up_row_sent: "Sent to the card",
  cop_top_up_row_fee: "Card top-up fee ({{percent}} %)",
  cop_top_up_row_returned: "Returned to your wallet",
  cop_top_up_row_credit: "Reaches the card",
  cop_top_up_row_paid: "You paid",
  cop_top_up_row_sent_done: "Sent to the card",
  cop_top_up_row_credited: "Reached the card",
  cop_top_up_rate_hint: "Everything included: what you paid over what reached the card.",
  cop_top_up_rate_estimated_hint: "Estimated, everything included: confirmed once the card credits it.",
  cop_top_up_approx_note:
    "What arrives is an estimate: the card deducts its fee when it credits the deposit.",
  cop_top_up_irreversible: "Once confirmed, the top-up cannot be undone.",
  cop_top_up_review: "Review",
  cop_top_up_back: "Back",
  cop_top_up_confirm: "Load {{amount}}",
  cop_top_up_cancel: "Cancel",
  cop_top_up_close: "Close",
  cop_top_up_refresh_price: "Refresh price",
  cop_top_up_price_expired: "The price expired. Refresh it to continue.",
  cop_top_up_ticket_label: "Your top-up",
  cop_top_up_two_factor_description: "Confirm the {{amount}} top-up to card •••• {{last4}}.",
  cop_top_up_two_factor_required: "Turn on two-step verification to load cards.",
  cop_top_up_status_processing_title: "We are sending your top-up",
  cop_top_up_status_processing_body:
    "We convert your pesos and send them to the card. It usually takes a few minutes.",
  cop_top_up_status_delivered_title: "It reached the card",
  cop_top_up_status_delivered_body: "The card credits the balance as soon as it confirms the deposit.",
  cop_top_up_status_credited_title: "Done, the card has the balance",
  cop_top_up_status_credited_body: "{{amount}} were credited to card •••• {{last4}}.",
  cop_top_up_status_failed_title: "The top-up did not go through",
  cop_top_up_status_failed_body: "We returned the pesos to your wallet.",
  cop_top_up_keep_going: "You can close this window: the top-up keeps going.",
  cop_top_up_transit_wallet: "COP wallet",
  cop_top_up_transit_card: "Card",
  cop_top_up_transit_aria:
    "Your pesos leave the COP wallet, Coloca turns them into USDT and they travel over {{network}} to the card •••• {{last4}}.",
  cop_top_up_error_generic: "We could not create the top-up.",
  cop_top_up_error_unconfirmed:
    "We got no answer, and the top-up may have gone through. Before you can place another, we check what happened to this one, so you are never charged twice.",
  cop_top_up_check_unconfirmed: "Check the top-up",
  cop_top_up_check_pending: "We don't have the answer yet. Check again in a few seconds.",
  cop_top_up_check_not_placed:
    "The previous top-up did not go through and you were not charged. You can get a new price.",
  cop_top_up_vanished:
    "This top-up was refused before buying: it did not go through and you were not charged.",
  cop_top_up_start_over: "Get a new price",
  txn_type_deposit_cop: "Top-up from pesos",
  card_wallet_invite_eyebrow: "Card wallet",
  card_wallet_invite_title: "Need to take balance back from your cards?",
  card_wallet_invite_body: "A dollar balance that connects all your cards.",
  card_wallet_invite_cta: "See how it works",
  card_wallet_invite_status: "Not active",
  card_wallet_invite_steps_label: "How it works",
  card_wallet_invite_step_withdraw: "Take balance off a card",
  card_wallet_invite_step_hold: "It waits in the wallet",
  card_wallet_invite_step_load: "Move it to another, instantly",
  card_wallet_invite_dismiss: "Not now",
  card_wallet_invite_dismissed_title: "Done, you won't see this again",
  card_wallet_invite_dismissed_body:
    "If you later need to take balance back from your cards, turn the wallet on from Settings.",
  card_wallet_invite_dismissed_action: "Go to Settings",
  card_wallet_enable_title: "Card wallet",
  card_wallet_enable_lead: "A dollar balance that connects all your cards.",
  card_wallet_enable_point_withdraw_title: "Take balance back from any card",
  card_wallet_enable_point_withdraw_body: "What you take back returns to the wallet, ready to use.",
  card_wallet_enable_point_load_title: "Load cards instantly",
  card_wallet_enable_point_load_body:
    "Move balance from the wallet to a card in seconds, with no deposit fee.",
  card_wallet_enable_point_total_title: "Your whole balance in one place",
  card_wallet_enable_point_total_body: "See what's in the wallet and what's on each card.",
  card_wallet_enable_funding_note:
    "Balance enters the wallet when you take it back from a card or when Coloca credits it.",
  card_wallet_enable_permanent_note: "Once it's on, only support can turn it off.",
  card_wallet_enable_cta: "Turn on card wallet",
  card_wallet_enable_cancel: "Not now",
  card_wallet_enable_success_title: "Card wallet is on",
  card_wallet_enable_success_body:
    "You can now take balance back from your cards and load them from the wallet.",
  card_wallet_enable_done: "Done",
  card_wallet_enable_error: "We couldn't turn on the card wallet. Try again.",
  card_wallet_enable_no_permission: "Ask an admin of your organization to turn it on.",
  card_wallet_diagram_aria:
    "The card wallet in the middle, with balance going to and coming back from your cards",
  card_wallet_diagram_wallet: "Wallet",
  first_card_eyebrow: "Your first card",
  first_card_title: "Create your first card",
  first_card_body:
    "It's issued in the name of a person or company, and you manage it from here. Here's what you need:",
  first_card_step_security_title: "A security method",
  first_card_step_security_body:
    "A security PIN or the authenticator app. You use it to confirm the issuance and to see the card details.",
  first_card_step_holder_title: "A verified holder",
  first_card_step_holder_body:
    "The person or company the card is issued to. You can create them while issuing it; they must finish identity verification before getting the card.",
  first_card_step_balance_title: "Balance to use it",
  first_card_step_balance_body: "Once it's issued, you load it and it's ready to pay.",
  first_card_status_done: "Done",
  first_card_status_in_review: "In verification",
  first_card_status_pending: "Pending",
  first_card_status_after: "After issuing",
  first_card_cta: "Create my first card",
  first_card_holders_link: "View holders",
  first_card_diagram_security: "Security",
  first_card_diagram_holder: "Holder",
  first_card_diagram_balance: "Balance",
  first_card_diagram_card: "Your card",
  first_card_diagram_aria:
    "With a security method and a verified holder the card is issued; then it is loaded with balance and ready",
  card_load_title: "Load card",
  card_load_description: "Card •••• {{last4}}",
  card_load_step_source: "How",
  card_load_step_details: "Details",
  card_load_source_heading: "How do you want to load it?",
  card_load_source_cop: "From pesos",
  card_load_source_cop_hint: "Use your peso balance. Arrives in about {{minutes}} min.",
  card_load_source_cop_hint_plain: "Use your peso balance; the card receives it in dollars.",
  card_load_source_cop_balance: "Available: {{amount}}",
  card_load_source_crypto: "Sending crypto",
  card_load_source_crypto_hint: "USDT or USDC on the Polygon network. Usually takes 2 to 10 min.",
  card_load_source_wallet: "From the card wallet",
  card_load_source_wallet_hint: "Instant · {{amount}} available",
  card_load_source_wallet_hint_plain: "Instant, from the wallet balance",
  card_load_no_withdraw_notice:
    "What you load stays on the card: it can't be taken back, only moved to another of your cards.",
  card_load_empty_title: "This card has no way to be loaded yet",
  card_load_empty_body:
    "Write to support and we'll turn on loading from pesos or crypto for your organization.",
  card_load_error: "We couldn't read how this card can be loaded.",
  card_load_retry: "Retry",
  card_load_continue: "Continue",
  card_load_cancel: "Cancel",
  card_load_back: "Back",
  card_load_close: "Close",
  card_load_unavailable_crypto_off: "Loading with crypto isn't on for your organization yet.",
  card_load_unavailable_card_inactive: "The card must be active.",
  card_load_unavailable_card: "This card can't be loaded this way.",
  card_load_unavailable_generic: "Not available right now.",
  card_load_crypto_next_title: "What happens next",
  card_load_crypto_next_send: "You send USDT or USDC to this address, on the Polygon network",
  card_load_crypto_next_confirm: "The network confirms the transaction",
  card_load_crypto_next_credit: "It's credited to your card, minus the deposit fee",
  card_load_crypto_eta: "It usually takes 2 to 10 minutes.",
  card_load_timeline_aria: "Load progress",
  card_load_stage_debited: "Pesos debited",
  card_load_stage_sending: "Buying USDT and sending it",
  card_load_stage_arrived: "Reached your card",
  card_load_stage_credited: "Credited to your card",
  card_load_stage_failed: "The purchase failed; your pesos were returned",
  card_load_stage_state_done: "Done",
  card_load_stage_state_active: "In progress",
  card_load_stage_state_pending: "Pending",
  card_load_stage_state_failed: "Failed",
  card_detail_receive_crypto_title: "Receive crypto",
  card_detail_action_withdraw: "Withdraw",
  cop_top_up_ack_no_withdraw:
    "I understand this balance can't be taken back from the card; I can only move it to another of my cards.",
  balance_modal_move_all: "Move the whole balance",
  balance_modal_move_all_hint:
    "Includes the fractions of a cent fees leave behind, so the card ends at zero.",
  balance_modal_move_success_all: "Moved the whole balance to the other card.",
};
